import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "nerv-readout-label" }
const _hoisted_2 = { class: "nerv-readout-value nerv-phosphor" }
const _hoisted_3 = {
  key: 0,
  class: "nerv-readout-unit"
}
const _hoisted_4 = {
  key: 0,
  class: "nerv-caption"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nerv-readout", _ctx.tone ? `tone-${_ctx.tone}` : ''])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.label), 1),
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.value), 1),
      (_ctx.unit)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.unit), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.note)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.note), 1))
      : _createCommentVNode("", true)
  ], 2))
}